// extracted by mini-css-extract-plugin
export var content = "Testimonial-module--content--493ee";
export var dark = "Testimonial-module--dark--7bbee";
export var icon = "Testimonial-module--icon--47a22";
export var iconEnd = "Testimonial-module--iconEnd--487db";
export var profileContainer = "Testimonial-module--profileContainer--302d0";
export var testimonial = "Testimonial-module--testimonial--341e3";